import FetchError from "./errors";
import { IUpdateUserSettingsRequest, IUserActivity, IUserSettings, IUserSettingsRequest, IUserUpdateLogoRequest, InfoField } from "../models";
import { customFetchWithRetry } from "./shared";
import { IUserProfile } from "src/models/UserProfile";

export const logUserActivity = async (request: IUserActivity): Promise<Boolean | null> => {
  try {
    const response = await customFetchWithRetry(`/user/${request.username}/activity`, {
      method: "POST",
      body: JSON.stringify(request)
    })
    if (response.ok) {
      return true;
    }

    throw new FetchError(`Error fetching. ${await response.text()}`, response.status);
  } catch (e) {
    throw new FetchError(e, 500);
  }
};

export const getUserProfile = async (): Promise<IUserProfile | null> => {
  try {
    const response = await customFetchWithRetry(`/client/userProfile`, {
      method: "GET"
    })
    if (response.ok) {
      return response.json();
    }

    throw new FetchError(`Error fetching. ${await response.text()}`, response.status);
  } catch (e) {
    throw new FetchError(e, 500);
  }
};

export const getUserSettings = async (request: IUserSettingsRequest): Promise<IUserSettings | null> => {
  try {
    const queryParams: string[] = [];
    if (request.orgId !== undefined) queryParams.push(`orgId=${encodeURIComponent(`${request.orgId}`)}`);
    if (request.grainId !== undefined) queryParams.push(`grainId=${encodeURIComponent(`${request.grainId}`)}`);
    if (request.profileId !== undefined) queryParams.push(`profileId=${encodeURIComponent(`${request.profileId}`)}`);
    const isParticleDistribution = request.settingName?.startsWith('particle_distribution_');
    if (request.settingName !== undefined && !isParticleDistribution) {
      queryParams.push(`settingName=${encodeURIComponent(request.settingName)}`);
    }
    const response = await customFetchWithRetry(`/user/${encodeURIComponent(request.username)}/settings?${queryParams.join('&')}`, {
      method: "GET"
    })
    if (response.ok) {
      return response.json();
    }

    throw new FetchError(`Error fetching. ${await response.text()}`, response.status);
  } catch (e) {
    throw new FetchError(e, 500);
  }
};

export const getUserInfoFields = async (request: IUserSettingsRequest): Promise<InfoField[] | null> => {
  try {
    const response = await customFetchWithRetry(`/user/${request.username}/settings?orgId=${request.orgId}&grainId=${request.grainId}&profileId=${request.profileId}&settingName=info_fields`, {
      method: "GET"
    })
    if (response.ok) {
      const result = await response.json();
      return result.info_fields || [];
    }

    throw new FetchError(`Error fetching. ${await response.text()}`, response.status);
  } catch (e) {
    throw new FetchError(e, 500);
  }
};

export const updateUserSettings = async (request: IUpdateUserSettingsRequest): Promise<IUserSettings | null> => {
  try {
    const response = await customFetchWithRetry(`/user/${request.username}/settings`, {
      method: "POST",
      body: JSON.stringify(request)
    })
    if (response.ok) {
      return response.json();
    }

    throw new FetchError(`Error fetching. ${await response.text()}`, response.status);
  } catch (e) {
    throw new FetchError(e, 500);
  }
};

export const patchUserSettings = async (request: IUpdateUserSettingsRequest): Promise<IUserSettings | null> => {
  try {
    const response = await customFetchWithRetry(`/user/${request.username}/settings`, {
      method: "PUT",
      body: JSON.stringify(request)
    })
    if (response.ok) {
      return response.json();
    }

    throw new FetchError(`Error fetching. ${await response.text()}`, response.status);
  } catch (e) {
    throw new FetchError(e, 500);
  }
};

export const updateUserLogo = async (request: IUserUpdateLogoRequest): Promise<IUserSettings | null> => {
  try {
    const response = await customFetchWithRetry(`/user/${request.username}/settings`, {
      method: "PUT",
      body: JSON.stringify(request)
    })
    if (response.ok) {
      return response.json();
    }

    throw new FetchError(`Error fetching. ${await response.text()}`, response.status);
  } catch (e) {
    throw new FetchError(e, 500);
  }
};

export const globalLogout = async (username: string): Promise<string | null> => {
  try {
    const response = await customFetchWithRetry(`/user/logout`, {
      method: "POST",
      body: JSON.stringify({
        "username": username
      })
    }, false)
    if (response.ok) {
      return "SUCCESS";
    }

    throw new FetchError(`Error fetching. ${await response.text()}`, response.status);
  } catch (e) {
    throw new FetchError(e, 500);
  }
};
